import { useEffect, useState } from 'react';
import useCheckTeams from './useCheckTeams';
import _ from 'lodash';
import { WIZARD_STEPS } from '../SyncGitTeamsWizard';

const useSyncGitTeamsForm = ({
  wizardStep,
  providerTeams,
  sensorAuthId,
  orgName,
  gitSelectedSyncTeamsSetting
} = {}) => {
  const [selectedTeam, setSelectedTeam] = useState(null);

  const {
    checkedTeams,
    toggleTeamCheckbox,
    isTeamChecked,
    isTeamChildChecked,
    setCheckedTeams,
    total,
    isCalculatingTotal
  } = useCheckTeams();

  const onClickTeam = team => setSelectedTeam(team);

  const providerTeamsToKeys = providerTeams =>
    providerTeams.reduce(
      (acc, providerTeam) => ({
        ...acc,
        [providerTeam.id]: providerTeam,
        ...providerTeamsToKeys(_.get(providerTeam, 'children', []))
      }),
      {}
    );

  const checkDefaultSyncTeams = () => {
    const selectedProviderIds =
      gitSelectedSyncTeamsSetting.getSelectedProviderIds(sensorAuthId, orgName);
    const providerTeamsKeys = providerTeamsToKeys(providerTeams);

    const defaultSelectedTeams = selectedProviderIds
      .map(providerId => _.get(providerTeamsKeys, providerId))
      .filter(Boolean);
    setCheckedTeams(defaultSelectedTeams);
  };

  useEffect(() => {
    checkDefaultSyncTeams();
  }, [providerTeams]);

  useEffect(() => {
    if (wizardStep === WIZARD_STEPS.GIT_ORG_SELECTION) {
      setSelectedTeam(null);
    }
  }, [wizardStep]);

  return {
    selectedTeam,
    providerTeams,
    onClickTeam,
    toggleTeamCheckbox,
    isTeamChecked,
    isTeamChildChecked,
    total,
    isCalculatingTotal,
    checkedTeams
  };
};

export default useSyncGitTeamsForm;
